<!--
 * @Description: 
 * @Author: 长老
 * @Date: 2019-07-31 09:57:55
 * @LastEditTime: 2022-01-14 10:26:10
 * @LastEditors: kuanggf
 -->
<template>
  <div class="category-view new">
    <div class="category-wrapper" v-if="categoryData.length > 0 || bannerData.length > 0">
     <!-- banner图 -->
      <div class="banner-bar" v-for="(item, index) in bannerData" v-show="bannerData.length > 0" :key="index" @click="nextPage(item, 1)">
        <img :src="item.pictureUrl | filterWebp" onerror="this.src='//static.yunjiweidian.com/qnUpload/frontend/logo/icon-bitmap.png'">
      </div>
      <!-- 浏览足迹 是第一个,并且guideDataType=5,historyCount>0-->
      <!-- 类目列表 -->
      <div class="category-list">
        <ul class="category-group" v-if="categoryData.length > 0">
          <li class="group-bar" v-for="(itemTwo, indexTwo) in categoryData" v-show="itemTwo.guideDataVOS.length > 0" :key="indexTwo">
              <div class="group-hearder">
                <span class="header-title">{{itemTwo.guideListName}}</span>
                <span class="header-more" v-if="(itemTwo.rankId&&itemTwo.guideViewType == 2 && itemTwo.guideDataType != 3)||(itemTwo.guideViewType == 3 && itemTwo.guideDataType != 3)" @click="nextPage(itemTwo, itemTwo.guideViewType)">{{itemTwo.guideViewType | showMore}}</span>
                <span class="header-del" @click="removeItem" v-if="itemTwo.guideDataType == 5 && itemTwo.historyCount > 0">清空</span>
              </div>
              <ul class="group-list" v-if="itemTwo.guideDataVOS.length > 0">
                <li class="group-item" v-for="(itemThree,indexThree) in itemTwo.guideDataVOS" v-show="(+appCont===7?itemThree.guideName!='云集好课':true)&&itemTwo.guideDataType != 5 && ((indexThree < 8 && itemTwo.guideDataType == 3) || itemTwo.guideDataType != 3)"  @click="tapCategoryItem(itemTwo, indexThree, itemThree)" :key="itemThree.categoryLevelId">
                  <img :src="itemThree.picture | filterWebp" onerror="this.src='//static.yunjiweidian.com/qnUpload/frontend/logo/icon-bitmap1.png'">
                  <span v-show="itemTwo.guideDataType != 3">{{itemThree.guideName}}</span>
                </li>
                <li class="group-item" v-for="(itemThree,indexThree) in itemTwo.guideDataVOS" v-show="(+appCont===7?itemThree.guideName!='云集好课':true)&&itemTwo.guideDataType == 5 && indexThree < itemTwo.historyCount"  @click="clickHistory(itemTwo.guideDataType, itemTwo.guideListName, indexThree, itemThree)" :key="itemThree.categoryLevelId">
                  <img :src="itemThree.picture | filterWebp" onerror="this.src='//static.yunjiweidian.com/qnUpload/frontend/logo/icon-bitmap1.png'">
                  <span v-show="itemTwo.guideDataType != 3">{{itemThree.guideName}}</span>
                </li>
                <li class="group-item" @click="tapBrandMore(itemTwo)" v-if="itemTwo.guideDataVOS.length > 8 && itemTwo.guideDataType == 3">
                  <span class="group-item-more">查看<br>更多</span>
                </li>
              </ul>
          </li>
        </ul>
      </div>
    </div>
    <no-result :status="status" v-else @reloadData="reloadData" :isCategory="true"></no-result>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Toast } from 'mint-ui'
import NoResult from '@/pages/commodity/components/NoResult/NoResult.vue'
// eslint-disable-next-line import/extensions
import YunJi from '@/assets/js/YunJi'

const { mapState, mapActions } = createNamespacedHelpers('categoryNav')
export default {
  components: {
    NoResult
  },
  props: ['pageId'],
  data() {
    return {
      historyFootprintIfon: '',
      isRepeat: true
    }
  },
  computed: {
    ...mapState({
      isApp: state => state.isApp,
      appCont: state => state.appCont,
      shopId: state => state.shopId,
      bannerData: state => state.bannerData,
      categoryData: state => state.categoryData,
      historyFootprint: state => state.historyFootprint,
      plName: state => state.parentLevelName,
      categoryId: state => state.categoryId,
      searchType: state => state.searchType,
      ticket: state => state.ticket,
      // eslint-disable-next-line no-nested-ternary
      status: state => (state.isReq ? 3 : state.isErr ? 2 : 1)
    })
  },
  filters: {
    showMore(val) {
      return val == 2 ? '热销榜' : '查看更多'
    }
  },
  mounted() {
    
  },
  methods: {
    ...mapActions(['queryCategoryData', 'queryCategoryName']),
    /**
     * 点击进入下一级
     * data 为子数据集 如不存在表示子集超过8个点击的查看更多
     * dataType 导购数据类型 1 手动添加 2选择类目 3选择品牌 5常用历史
     * type 1 足迹点击
     */
    tapCategoryItem(itemTwo, index, data) {
      const { guideDataType, guideListName, jumpWay } = itemTwo
      this.reportData(guideDataType, guideListName, index, data)
      if (guideDataType == 1 || guideDataType == 5) {
        // 根据data.contentType值跳转相应的页面
        this.toOtherPage(data)
      } else if (guideDataType == 2) {
        // 跳搜索
        if (jumpWay === 1) {
          this.toSearch(data.guideName)
        // 跳转商品列表页
        } else {
          this.toCommodityPage(data)
        }
      } else {
        // 跳转品牌列表页
        this.toBrandPage(data)
      }
    },
    // 跳搜索列表
    toSearch(searchName) {
      const url = `${window.location.protocol}//${window.globalConfig.yjbuyerPath}/yjbuyer/search-list?appCont=${this.appCont}&shopId=${this.shopId}&searchContent=${encodeURIComponent(searchName)}&isCategory=1&tagType=1&hideNavBar=true`
      if (this.isApp) {
        window.location.href = `yunji://common/searchList?value=${searchName}&newChannelId=${this.searchType}&searchContent=${encodeURIComponent(searchName)}`
      } else {
        window.location.href = url
      }
    },
    /**
     * 上报曝光埋点数据和点击事件的数据
     */
    reportData(dataType, dataName, index, data) {
    // console.log("this.pageId:"+this.pageId+"===this.plName:"+this.plName+"===dataName:"+dataName+"===data.contentType："+data.contentType+"==dataType"+dataType+"==data.content.split(',')[1]"+data.content.split(',')[1]+"==data.content.split(',')[0]"+data.content.split(',')[0]+"==data.guideName:"+data.guideName+"==index:"+(index + 1));
      window.thinkingReport.track('exposure', {
        point_id: '22786',
        page_id: this.pageId,
        tab_name: this.plName,
        sub_tab_name: dataName,
        third_tab_name: data.guideName
      })
      // 埋点
      window.thinkingReport.track('click_list', {
        page_id: this.pageId,
        catelog_tab_name: this.plName,
        entrance_tab_name: dataName,
        content_type: data.contentType || dataType,
        content_id: data.content.split(',')[1] || data.content.split(',')[0],
        content_name: data.guideName,
        list_index: index + 1
      })
    },
    /**
     * 清除浏览足迹缓存
     */
    removeItem() {
      window.localStorage.removeItem('historyFootprint')
      this.$store.commit('categoryNav/SETHISTORYFOOTPRINT', [])
      if (this.categoryData && this.categoryData.length > 0) {
        this.categoryData.forEach((item) => {
          if (item.guideDataType == 5 && item.historyCount > 0) {
            item.guideDataVOS = []
          }
        })
      }
    },
    /**
     * 缓存历史足迹
     */
    storageIfon(obj) {
      if (this.historyFootprint && this.historyFootprint.length > 0) {
        this.historyFootprint.forEach((item) => {
          if (obj.content == item.content) {
            this.isRepeat = false
          }
        })
      }
      if (this.isRepeat) {
        if (this.historyFootprint.length > 19) {
          this.historyFootprint.pop() // 当数量超过20,再次点击另外一个后把最后一个元素删除
        }
        this.historyFootprint.unshift(obj) // 往新数组插入点击过的足迹
        this.historyFootprintIfon = JSON.stringify(this.historyFootprint) // 转换成字符串
        window.localStorage.setItem('historyFootprint', this.historyFootprintIfon) // 掺入缓存
      }
      this.isRepeat = true
    },
    /**
     * 历史记录点击
     */
    clickHistory(dataType, dataName, index, data) {
      this.reportData(dataType, dataName, index, data)
      if (data.contentType) {
        this.toOtherPage(data, 1)
        return
      }
      if (data.content && data.content.indexOf(',') > -1) {
        this.toCommodityPage(data, 1)
      } else {
        this.toBrandPage(data, 1)
      }
    },
    // 跳转商品列表页
    toCommodityPage(data, type) {
      if (type != 1) {
        this.storageIfon(data)
      }
      const categoryId = data.content.split(',')[0]
      const categoryLevelId = data.content.split(',')[1]
      const categoryName = this.plName
      const { shopId } = this
      if (this.isApp) {
        const appStr = `goNewGoodsGategory?categoryId=${categoryId}&categoryLevelId=${categoryLevelId}&userType=2&categoryName=${categoryName}` // App跳转地址
        this.toAppPage(appStr)
      } else {
        // H5跳转地址
        this.$router.push({ 
          path: '/commodity-list', 
          query: {
            categoryLevelId, 
            categoryId, 
            appCont: this.appCont || 0,
            ticket: this.ticket,
            shopId 
          } 
        })
      }
    },
    // 跳转品牌墙
    toBrandPage(data = {}, type) {
      if (type != 1) {
        this.storageIfon(data)
      }
      if (this.isApp) {
        const appStr = `goBrandHallPage?id=${data.content}` // App跳转地址
        this.toAppPage(appStr)
      } else {
        // H5跳转地址
        const str = `yjbuyer/brand-index?brandId=${data.content}&appCont=${this.appCont}`
        this.toH5Page(str)
      }
    },
    // 跳转自定义页面
    toOtherPage(data, type) {
      if (type != 1) {
        this.storageIfon(data)
      }
      let str = '' // H5跳转地址
      let appStr = '' // App跳转地址
      let routerObj = null

      if (data.guideViewType == 2 && data.rankId) {
        const url = `${window.location.origin}/yjbuyer/rankingList?hideNavBar=true&appCont=${this.appCont}&strVersion=0&storeId=${data.rankId}&sceneType=4&shopId=${this.shopId}&ticket=${this.ticket}`
        if (this.isApp) {
          window.location.href = `yunji://gotoExternalLink?url=${encodeURIComponent(url)}` 
        } else {
          window.location.href = url
        }
        return
      }
      if (data.contentType) {
        switch (Number(data.contentType)) {
          case 1:
            // 品牌馆
            str = `yjbuyer/brand-index?brandId=${data.content}&appCont=0`
            appStr = `goBrandHallPage?id=${data.content}`
            break
          case 2:
            // 专题
            str = `yj/subject?appCont=0&subjectId=${data.content}`
            appStr = `gotoSubject?subjectId=${data.content}`
            break
          case 3:
            // 商详
            str = `yjbuyer/detail?appCont=0&itemId=${data.content}`
            appStr = `itemDetail?itemId=${data.content}&limitActivityId=${data.limitActivityId}`
            console.log(YunJi.isWxProgram(), 'a判断是否是小程序环境')
            if (YunJi.isWxProgram() || parseInt(this.appCont, 10) === 7) {
              // 小程序环境下
              const itemStr = `?origin=1&shopId=${this.shopId}&itemId=${data.content}`
              YunJi.useWxMini(() => {
                wx.miniProgram.navigateTo({
                  url: `../detail/detail${itemStr}`
                })
              })
              return
            }
            // window.location.href = `//${globalConfig.linkBasePath}/yjbuyer/detail?itemId=${data.content}&shopId=${this.shopId}&appCont=${this.appCont}`
            break
          // eslint-disable-next-line no-case-declarations
          case 4:
            // 商品类目
            const categoryId = data.content.split(',')[0]
            const categoryLevelId = data.content.split(',')[1]
            const categoryName = this.plName
            routerObj = { 
              path: '/commodity-list', 
              query: { 
                categoryLevelId, 
                categoryId, 
                appCont: this.appCont || 0, 
                ticket: this.ticket,
                shopId: this.shopId 
              } 
            }
            appStr = `goNewGoodsGategory?categoryId=${categoryId}&categoryLevelId=${categoryLevelId}&userType=2&categoryName=${categoryName}`
            break
          case 5:
            // 店铺页
            str = `yjbuyer/shop?appCont=${this.appCont}&storeCode=${data.content}&ticket=${this.ticket}`
            appStr = `goPopShopHome?storeCode=${data.content}`
            break
          case 6:
            // 自定义
            this.nextPageByUrl(data.content)
            return
          case 7:
            // 搜索
            this.toSearch(data.content)
            return
          default:
            Toast('数据异常，无法操作')
            return
        }
        if (this.isApp) {
          this.toAppPage(appStr)
        } else if (routerObj) {
          this.$router.push(routerObj)
        } else {
          this.toH5Page(str)
        }
      } else {
        this.toCommodityPage(data, 1)
      }
    },
    toAppPage(url) {
      const urlS = url.split('?')[0]
      const arr = ['goBandCategory', 'goNewGoodsGategory']
      if (arr.includes(urlS)) {
        if (YunJi.appUA && YunJi.appUA.appIdForH5 >= '20190426') window.location.href = `yunji://common/${url}`
      } else {
        window.location.href = `yunji://common/${url}`
      }
    },
    toH5Page(url) {
      if (this.shopId) url = `${url}&shopId=${this.shopId}`
      window.location.href = `//${window.globalConfig.buyerBasePath}/${url}`
    },
    /**
     * 点击右上角热销/更多执行的操作
     * 配置热销/更多,会绑定对应的链接，直接跳转
     * type 1-banner 2-热销 3-更多
     */
    nextPage(data, type) {
      const repT = 'others'
      const repD = {}
      if (type == 1) {
        repD.operation_name = 'btn_banner'
        repD.catelog_tab_name = this.plName
        repD.point_id = '21627'
        window.thinkingReport.track('exposure', {
          page_id: this.pageId,
          point_id: '22785',
          tab_name: this.plName
        })
      } else if (type == 2) {
        repD.operation_name = 'btn_热销榜'
        repD.point_id = '22787'
        repD.entrance_tab_name = data.guideListName || '其他'
        window.thinkingReport.track('exposure', {
          page_id: this.pageId,
          point_id: '22785',
          tab_name: this.plName,
          sub_tab_name: data.guideListName
        })
      } else if (type == 3) {
        repD.operation_name = 'btn_查看更多'
        repD.point_id = '21955'
        repD.entrance_tab_name = data.guideListName || '其他'
        window.thinkingReport.track('exposure', {
          page_id: this.pageId,
          point_id: '22788',
          tab_name: this.plName,
          sub_tab_name: data.guideListName
        })
      }
      repD.page_id = this.pageId
      // 埋点
      if (repD.operation_name) window.thinkingReport.track(repT, repD)
      this.toOtherPage(data, 1)
    },
    nextPageByUrl(url) {
      if (!url) return
      let query = url.split('?')[1] // 获取地址后的参数
      const param = {}
      if (url.includes('brand-list') || url.includes('goBandCategory')) {
        param.contentType = 1
      } else if (url.includes('subject') || url.includes('gotoSubject')) {
        param.contentType = 2
      } else if (url.includes('yjbuyer/detail') || url.includes('itemDetail')) {
        param.contentType = 3
      } else if (url.includes('commodity-list') || url.includes('goNewGoodsGategory')) {
        param.contentType = 4
      } else if (url.includes('yjbuyer/shop') || url.includes('goPopShopHome')) {
        param.contentType = 5
      } else {
        /**
         * !url.includes('shopId') 判断链接是否没有shopId
         * this.shopId 判断是否存在shopid
         * url.includes('?') 区分长短链接 短连接不加参数
         */
        if (!url.includes('shopId') && this.shopId && url.includes('?')) url = `${url}&shopId=${this.shopId}`
        if (this.isApp) {
          url = `yunji://gotoExternalLink?url=${encodeURIComponent(url)}`
        }
        window.location.href = url
        return
      }
      if (query) {
        query = query.split('&')
        for (let i = 0; i < query.length; i += 1) {
          if (query[i]) {
            const key = query[i].split('=')[0]
            const val = query[i].split('=')[1]
            param[key] = val
          }
        }
      }
      this.toOtherPage(param)
    },
    // 重新加载数据， 无菜单栏则刷新queryCategoryName接口
    reloadData() {
      if (this.categoryId) {
        this.queryCategoryData()
      } else {
        this.queryCategoryName()
      }
    },
    // 点击更多跳转品牌列表
    tapBrandMore(data) {
      if (this.isApp) {
        const appStr = `goBandCategory?categoryId=${data.extra}` // App跳转地址
        this.toAppPage(appStr)
      } else {
        // H5跳转地址
        const { shopId } = this
        const categoryId = data.extra
        this.$router.push({ path: '/brand-list', query: { appCont: 0, shopId, categoryId } })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.category-view{
  box-sizing: border-box;
  width: 100%;
  flex: 1;
  height: 100%;
  overflow-y: auto;
  &.new{
    padding-left: 0;
  }
  .category-wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 0.24rem 0.24rem;
    box-sizing: border-box;
    border-radius: 0.12rem;
    background-color: #fff;
    .banner-bar{
      flex: 1;
      height: 1.44rem;
      background-color: #f2f2f2;
      margin-top: 0.24rem;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .category-list{
      .category-group{
        .group-bar{
          .group-hearder{
            display: flex;
            justify-content: space-between;
            margin-top: 0.56rem;
            font-size: 0.28rem;
            .header-title{
              color: #212121;
              font-weight: 700;
              font-size: .28rem;
            }
            .header-more{
              color: #EE2532;
              &::after{
                content: '';
                display: inline-block;
                height: 0.32rem;
                width: 0.32rem;
                margin-left: 0.08rem;
                vertical-align: sub;
                background-image: url('../img/icon-right1.png');
                background-repeat: no-repeat;
                background-size: 100%;
              }
            }
            .header-del{
              color: #212121;
              font-size: .24rem;
              &::after{
                content: '';
                display: inline-block;
                height: 0.28rem;
                width: 0.28rem;
                margin-left: 0.08rem;
                vertical-align: sub;
                background-image: url('../img/icon-del.png');
                background-repeat: no-repeat;
                background-size: 100%;
              }
            }
          }
          .group-list{
            display: flex;
            flex-wrap: wrap;
            .group-item{
              display: flex;
              flex-direction: column;
              align-items: center;
              width: 33.3%;
              margin-top: 0.32rem;
              color: #212121;
              img{
                width: 1.28rem;
                height: 1.28rem;
                margin-bottom: 0.08rem;
              }
              span{
                width: 1.28rem;
                text-align: center;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .group-item-more{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 1.28rem;
                height: 1.28rem;
                background-color: #f2f2f2;
              }
            }
          }
        }
      }
    }
  }
}
</style>
